import cn from "classnames"

import { Asset } from "~/components/primitives/Asset/Asset"

import type { PeopleHeroCard } from "./PeopleHero.interface"
import s from "./PeopleHeroCard.module.scss"

export const PeopleHeroCardItem = ({
  card,
  index,
  isActive,
  onActivate,
  onDeactivate,
}: {
  card: PeopleHeroCard
  index: number
  isActive: boolean
  onActivate: () => void
  onDeactivate: () => void
}) => {
  const content = (
    <>
      <span className={s.backdrop} aria-hidden="true" />
      <span className={s.imageWrap}>
        <Asset
          className={s.image}
          asset={card.image}
          imageSizes={{ base: "70vw", sm: "35vw", md: "31rem", xl: "32rem" }}
          objectFit="cover"
          loading="lazy"
          hasPriority={index < 2}
        />
      </span>
      {card.badgeText && (
        <span
          className={s.badge}
          dangerouslySetInnerHTML={{ __html: card.badgeText }}
        />
      )}
    </>
  )

  const className = cn(s.card, isActive && s["card--active"])

  if (card.link?.url) {
    const isExternal = /^https?:\/\//.test(card.link.url)
    const target = card.link.target || (isExternal ? "_blank" : undefined)

    return (
      <a
        className={className}
        href={card.link.url}
        target={target || undefined}
        rel={target === "_blank" ? "noopener noreferrer" : undefined}
        aria-label={card.badgeText ? `View ${card.badgeText}` : undefined}
        onFocus={onActivate}
        onBlur={onDeactivate}
        onPointerEnter={onActivate}
        onPointerLeave={onDeactivate}
      >
        {content}
      </a>
    )
  }

  return (
    <article
      className={className}
      onPointerEnter={onActivate}
      onPointerLeave={onDeactivate}
    >
      {content}
    </article>
  )
}
